import { createContext, useContext, useState } from "react";

export const translations = {
  it: {
    login: "Accedi",
    register: "Registrati",
    email: "Email",
    password: "Password",
    name: "Nome",
    forgotPassword: "Non ricordi la password?",
    firstTime: "Prima volta? Registrati",
    hasAccount: "Hai gia un account? Accedi",
    unlock: "Inserisci le tue credenziali per sbloccare il vault.",
    preloaded: "Crea il tuo account. 20 password saranno precaricate!",
    loading: "Caricamento...",
    logout: "Esci",
    search: "Cerca password...",
    addPassword: "Nuova password",
    noPasswords: "Nessuna password trovata",
    copy: "Copiato!",
    delete: "Elimina",
    edit: "Modifica",
    save: "Salva",
    cancel: "Annulla",
    allCategories: "Tutte",
    entries: "voci",
    yourPasswords: "Le tue password",
    backup: "Backup",
    restore: "Ripristina",
    print: "Stampa",
    users: "Utenti",
    install: "Scarica App",
    add: "Aggiungi",
    confirmDelete: "Eliminare",
    newEntry: "Nuova Voce",
    editEntry: "Modifica Voce",
    title: "Titolo",
    username: "Username / Email",
    website: "Sito Web",
    category: "Categoria",
    notes: "Note",
    generate: "Genera",
    weak: "Debole",
    medium: "Media",
    good: "Buona",
    strong: "Forte",
    addFirst: "Aggiungi la prima",
    sortAZ: "A-Z",
    sortRecent: "Recenti",
    connectionError: "Connessione al server fallita. Controlla internet e riprova.",
    offlineMode: "Modalita offline - dati dalla cache locale.",
    retryConnection: "Riprova connessione",
    resetTitle: "Recupero password",
    resetDescription: "Inserisci la tua email per ricevere le istruzioni di recupero.",
    resetWarning: "",
    resetNewEmail: "Email",
    resetNewPassword: "",
    resetConfirm: "",
    resetButton: "Invia richiesta",
    backToLogin: "Ritorna al Login",
    resetSent: "Se l'email e' registrata, riceverai istruzioni per il recupero.",
    resetConfirmMsg: "",
    passwordsNotMatch: "Le password non coincidono",
    minPassword: "La password deve essere di almeno 6 caratteri",
    enterEmail: "Inserisci la tua email",
    enterPassword: "Inserisci la password",
    freePlan: "Piano Free",
    premiumPlan: "Piano Premium",
    upgradeTitle: "Scegli il tuo piano",
    upgradeDesc: "Password illimitate, backup, sync multi-dispositivo",
    monthly: "2,99 € · 1 mese",
    yearly: "19,99 € · 1 anno",
    upgrade: "Passa a Premium",
    freeLimit: "Hai raggiunto il limite di 10 password del piano Free.",
    goBack: "Torna indietro",
    paymentSoon: "Pagamento SumUp non configurato.",
    sumupConsent: "",
    sumupSetup: "Continua al pagamento sicuro",
    sumupCard: "Inserisci i dati nel widget di pagamento sicuro SumUp.",
    sumupConfirm: "",
    sumupReady: "",
    sumupOneTime: "Pagamento una tantum, senza rinnovo automatico.",
    sumupOneTimeNotice: "Scegli la durata del Premium. Il pagamento è una tantum e non salva la carta.",
    sumupServerVerification: "Premium viene attivato solo dopo la verifica server-side del pagamento.",
    sumupLoading: "Caricamento del pagamento sicuro…",
    sumupWidgetError: "Non è stato possibile caricare il pagamento sicuro. Riprova.",
    sumupPaymentFailed: "Pagamento non completato o non ancora verificato.",
    sumupFormInvalid: "Controlla i dati di pagamento inseriti.",
    sumupPaid: "Pagamento verificato. Premium attivo.",
    billingRefresh: "Aggiorna stato",
    billingPending: "Pagamento in verifica lato server.",
    billingCancel: "",
    billingCanceled: "",
    free10: "Max 10 password",
    free1device: "1 dispositivo",
    freeBasic: "Funzioni base",
    premiumUnlimited: "Password illimitate",
    premiumMulti: "Multi-dispositivo",
    premiumBackup: "Backup & Ripristina",
    premiumPriority: "Supporto prioritario",
    currentPlan: "Piano attuale",
    adminPanel: "Gestione Utenti",
    totalUsers: "Totale utenti",
    activeUsers: "Attivi",
    blockedUsers: "Bloccati",
    freeUsers: "Free",
    premiumUsers: "Premium",
    promote: "Promuovi Premium",
    demote: "Declassa a Free",
    block: "Blocca",
    activate: "Attiva",
    deleteUser: "Elimina utente",
    registered: "registrati",
    backToDashboard: "Indietro",
    gestione: "Gestione Password",
    byAcaridi: "by ACaridi Digital App",
    importSuccess: "password importate!",
    backupSaved: "Backup salvato!",
    backupDownloaded: "Backup scaricato!",
    invalidFile: "File non valido. Usa un backup JSON.",
    importConfirm: "Importare {count} password dal backup?",
    passwordDeleted: "Password eliminata",
    passwordUpdated: "Password aggiornata",
    passwordAdded: "Password aggiunta",
    loginSuccess: "Accesso effettuato!",
    registerSuccess: "Registrazione completata!",
    vaultRecreated: "Vault ricreato!",
  },
  en: {
    login: "Sign In",
    register: "Sign Up",
    email: "Email",
    password: "Password",
    name: "Name",
    forgotPassword: "Forgot your password?",
    firstTime: "First time? Sign up",
    hasAccount: "Already have an account? Sign in",
    unlock: "Enter your credentials to unlock the vault.",
    preloaded: "Create your account. 20 passwords will be preloaded!",
    loading: "Loading...",
    logout: "Sign out",
    search: "Search passwords...",
    addPassword: "New password",
    noPasswords: "No passwords found",
    copy: "Copied!",
    delete: "Delete",
    edit: "Edit",
    save: "Save",
    cancel: "Cancel",
    allCategories: "All",
    entries: "entries",
    yourPasswords: "Your passwords",
    backup: "Backup",
    restore: "Restore",
    print: "Print",
    users: "Users",
    install: "Install App",
    add: "Add",
    confirmDelete: "Delete",
    newEntry: "New Entry",
    editEntry: "Edit Entry",
    title: "Title",
    username: "Username / Email",
    website: "Website",
    category: "Category",
    notes: "Notes",
    generate: "Generate",
    weak: "Weak",
    medium: "Medium",
    good: "Good",
    strong: "Strong",
    addFirst: "Add your first",
    sortAZ: "A-Z",
    sortRecent: "Recent",
    connectionError: "Connection to server failed. Check your internet and retry.",
    offlineMode: "Offline mode - showing cached data.",
    retryConnection: "Retry connection",
    resetTitle: "Password recovery",
    resetDescription: "Enter your email to receive recovery instructions.",
    resetWarning: "",
    resetNewEmail: "Email",
    resetNewPassword: "",
    resetConfirm: "",
    resetButton: "Send request",
    backToLogin: "Back to Login",
    resetSent: "If the email is registered, you will receive recovery instructions.",
    resetConfirmMsg: "",
    passwordsNotMatch: "Passwords do not match",
    minPassword: "Password must be at least 6 characters",
    enterEmail: "Enter your email",
    enterPassword: "Enter your password",
    freePlan: "Free Plan",
    premiumPlan: "Premium Plan",
    upgradeTitle: "Choose your plan",
    upgradeDesc: "Unlimited passwords, backup, multi-device sync",
    monthly: "€2.99 · 1 month",
    yearly: "€19.99 · 1 year",
    upgrade: "Upgrade to Premium",
    freeLimit: "You've reached the 10 password limit of the Free plan.",
    goBack: "Go back",
    paymentSoon: "SumUp payment is not configured.",
    sumupConsent: "",
    sumupSetup: "Continue to secure payment",
    sumupCard: "Enter your details in the secure SumUp payment widget.",
    sumupConfirm: "",
    sumupReady: "",
    sumupOneTime: "One-time payment, no automatic renewal.",
    sumupOneTimeNotice: "Choose your Premium duration. The payment is one-time and does not save your card.",
    sumupServerVerification: "Premium activates only after server-side payment verification.",
    sumupLoading: "Loading secure payment…",
    sumupWidgetError: "Secure payment could not be loaded. Please try again.",
    sumupPaymentFailed: "Payment was not completed or is not verified yet.",
    sumupFormInvalid: "Check the payment details you entered.",
    sumupPaid: "Payment verified. Premium is active.",
    billingRefresh: "Refresh status",
    billingPending: "Payment is being verified server-side.",
    billingCancel: "",
    billingCanceled: "",
    free10: "Max 10 passwords",
    free1device: "1 device",
    freeBasic: "Basic features",
    premiumUnlimited: "Unlimited passwords",
    premiumMulti: "Multi-device",
    premiumBackup: "Backup & Restore",
    premiumPriority: "Priority support",
    currentPlan: "Current plan",
    adminPanel: "User Management",
    totalUsers: "Total users",
    activeUsers: "Active",
    blockedUsers: "Blocked",
    freeUsers: "Free",
    premiumUsers: "Premium",
    promote: "Promote to Premium",
    demote: "Demote to Free",
    block: "Block",
    activate: "Activate",
    deleteUser: "Delete user",
    registered: "registered",
    backToDashboard: "Back",
    gestione: "Gestione Password",
    byAcaridi: "by ACaridi Digital App",
    importSuccess: "passwords imported!",
    backupSaved: "Backup saved!",
    backupDownloaded: "Backup downloaded!",
    invalidFile: "Invalid file. Use a JSON backup.",
    importConfirm: "Import {count} passwords from backup?",
    passwordDeleted: "Password deleted",
    passwordUpdated: "Password updated",
    passwordAdded: "Password added",
    loginSuccess: "Login successful!",
    registerSuccess: "Registration complete!",
    vaultRecreated: "Vault recreated!",
  }
};

const LangContext = createContext();

export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("pm_lang") || "it");
  function changeLang(l) { setLang(l); localStorage.setItem("pm_lang", l); }
  var t = translations[lang] || translations.it;
  return <LangContext.Provider value={{ lang, setLang: changeLang, t }}>{children}</LangContext.Provider>;
}

export function useLang() { return useContext(LangContext); }
